<template>
    <section id="Sermons" class="Sermons blue-grey lighten-5">
        <div class="row">
            <div class="col s12 center">
                <div class="more-sermons-heading">Watch More Sermons</div>
                <div class="arrow-down"><i class="arrow down"></i></div>
            </div>
        </div>
        <div class="row container other-sermons-container">
            <div class="col s12 m6 l4 other-sermons" v-for="(sermon, index) in sermons" :key="index" :index="index">
                <a href="javascript:;" v-on:click="loadSermon(sermon)">
                    <div :class="{'overlay': true, 'show': selectedSermon.VideoID == sermon.VideoID}">
                        <i v-if="selectedSermon.VideoID != sermon.VideoID" class="material-icons">play_circle_outline</i>
                        <i v-else class="material-icons">equalizer</i>
                    </div>
                    <img v-if="sermon.Status == 'LIVE'" :src="watchNowImage">
                    <img v-else-if="sermon.ImageURL != ''" :src="sermon.ImageURL">
                    <img v-else :src="latestSermonImage">
                    <div class="date">
                        <span class="live" v-if="sermon.Status == 'LIVE'">NOW LIVE</span>
                        {{ sermon.StreamDateFormatted }}
                    </div>
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col s12 center not-loading">
                Videos not loading? <a :href="facebookLive" target="_blank">Click Here</a>
            </div>
        </div>
    </section>
</template>

<script>

import ENV from '../../constants/Environment.js';

export default {
    name: "Sermons",
    props: ['sermons'],
    mounted: function() { 
    },
    data: function() {
        return {
            selectedSermon: {},
            watchNowImage: "https://res.cloudinary.com/olentini/image/upload/v1586053766/Sermons/WatchNow.jpg",
            latestSermonImage: "https://res.cloudinary.com/olentini/image/upload/v1586053766/Sermons/LatestSermon.jpg",
            facebook: ENV.FACEBOOK_LINK, 
            facebookLive: ENV.FACEBOOK_LIVE_LINK,
        }
    },
    methods: {
        loadSermon: function(pSermon) {
            this.$emit('selected', pSermon)
            this.selectedSermon = pSermon;
        }
    },    
    watch: {
        sermons: {
            // the callback will be called immediately after the start of the observation
            immediate: false, 
            deep: true,
            handler (val) {
                this.selectedSermon = val[0];
            }
        }
    }
};
</script>

<style scoped>
section {
    padding: 2rem 0rem 3.5rem 0rem;
}

.other-sermons-container {
    max-height: 600px;
    overflow-y: auto;
}
.more-sermons-heading {
    margin-bottom: .25rem;
    font-size: 3rem;
    line-height: 1.25;
    font-family: NewhouseDT-ExtraLight;
}
.other-sermons {
    position: relative;
    padding: 0;
    transition: all 0.5s ease;
    margin-bottom: 3.5rem;
}

.other-sermons:hover .overlay {
    display: block;
}

.other-sermons:hover {
    color: #ffffff;
}

.other-sermons .overlay {
    text-align: center;
    position: absolute; /* Sit on top of the page content */
    display: none; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0; 
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(9,12,13, .5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
    color: #ffffff;
}

.other-sermons .overlay.show {
    display: block;
}
.other-sermons .overlay i {
    font-size: 4rem;
    position:absolute;
    top: calc(50% - 30px);
    left: calc(50% - 25px);
}

.other-sermons img {
    width: 100%;
    display: block;
}

.other-sermons .date {
    position: absolute;
    display: block;
    font-size: 1rem;
    line-height: 1;
    text-transform: uppercase;
    left: 0;
    right: 0;
    transition: all 0.5s ease;
    padding-top: 10px;
    text-align: center;
    color: #222;
}

/* .other-sermons:hover .date {
    color: #eceff1;
} */

.other-sermons .date .live {
    font-size: 1.5rem;
    color: rgba(176,16,48, 1);
    font-family: NewhouseDTCond-ExtBold;
    margin-right: 10px;
}

.arrow-down {
    margin-bottom: 25px;
}
</style>